import React, { useEffect } from "react";
import { DataInputConstants, sideBarConstants } from "../constants";
import {
  ButtonShape,
  ButtonSize,
} from "../../../../enums/ButtonAttributesEnums";
import { InputfieldTypes } from "../../../../enums/InputFieldAttributesEnums";
import SearchIcon from "../../../../assets/images/inputSearchSuffix.svg";
import styles from "../DataInput.module.scss";
import Form from "../../../Form";
import InputField from "../../../../reusable-components/TNInputField";
import TNButton from "../../../../reusable-components/TNButton";
import { set, useFormContext } from "react-hook-form";

interface SearchInputProps {
  handleSearch: (val?: string) => void;
  setSearchState: (val?: string) => void;
  searchInputValue: string;
}

const TicketSearchInput = (props: SearchInputProps) => {
  const { handleSearch, setSearchState, searchInputValue } = props;
  const { watch } = useFormContext();

  const currentSearchValue = watch(sideBarConstants.SEARCH_FIELD_NAME);

  const addOnAfter = (
    <TNButton
      shape={ButtonShape.DEFAULT}
      size={ButtonSize.MEDIUM}
      className={styles.searchFieldButton}
      block
      text={
        <img
          className={styles.searchFieldIcon}
          src={SearchIcon}
          alt={DataInputConstants.SEARCH_ICON_ALT}
        />
      }
      onClick={() => handleSearch(currentSearchValue)}
    />
  );

  useEffect(() => {
    setSearchState(currentSearchValue);
  }, [currentSearchValue]);

  return (
    <div className={styles.pdfOptionSearch}>
      <InputField
        type={InputfieldTypes.TEXT}
        name={sideBarConstants.SEARCH_FIELD_NAME}
        placeholder={sideBarConstants.SEARCH_PLACEHOLDER}
        addonAfter={addOnAfter}
        value={searchInputValue}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            handleSearch(currentSearchValue);
          }
        }}
        maxTextLength={20}
      />
    </div>
  );
};

export default TicketSearchInput;
